{
  "viralRecording": {
    "status": {
      "loading": "Laden...",
      "loadingProcessData": "Prozessdaten werden geladen...",
      "loadingRecordingData": "Aufnahmedaten werden geladen..."
    },
    "buttons": {
      "startRecording": "Aufnahme starten",
      "finishing": "Fertigstellen...",
      "finishRecording": "Aufnahme beenden",
      "save": "Speichern",
      "delete": "Löschen",
      "addCondition": "Bedingung hinzufügen",
      "addRule": "Regel hinzufügen",
      "reorderRule": "Zum Umsortieren ziehen",
      "back": "Zurück",
      "addNewInput": "Eingang hinzufügen",
      "seeMoreAndChange": "Mehr sehen und ändern",
      "createStartEvent": "Startereignis erstellen"
    },
    "labels": {
      "startEvent": "Startereignis",
      "previousEvent": "Vorheriges Ereignis",
      "noDescriptionAvailable": "Keine Beschreibung verfügbar",
      "rule": "Regel",
      "ruleNumber": "Regel {{number}}",
      "unclear": "Unklar",
      "none": "Keine",
      "theProcessWillEndHere": "Der Prozess endet hier.",
      "iReceive": "Ich erhalte",
      "iDo": "Ich tue",
      "iUse": "Ich nutze",
      "iCreate": "Ich erstelle",
      "youLabel": "{{name}} (Du)",
      "event": "Ereignis",
      "information": "Information",
      "untitled": "Ohne Titel",
      "processStepDescription": "Prozessschritt-Beschreibung",
      "processInformation": "Gib den Prozessnamen und die Beschreibung an",
      "processDetailsOverview": "Überblick über die Stammdaten dieses Prozesses",
      "process": "Aktivität",
      "decision": "Entscheidung",
      "defineOutput": "Ausgabe definieren",
      "unknownUser": "Unbekannter Benutzer",
      "unknownRole": "Unbekannte Stelle",
      "processName": "Prozessname",
      "description": "Beschreibung",
      "organizationInfo": "Organisationsinformationen",
      "owner": "Prozessverantwortlicher",
      "createdBy": "Erstellt von",
      "department": "Abteilung",
      "timestamps": "Zeitstempel",
      "createdAt": "Erstellt am",
      "updatedAt": "Zuletzt aktualisiert",
      "decisionRules": "Entscheidungsregeln",
      "clickToOpen": "Klick, um die Entscheidungstabelle zu öffnen",
      "clickToEdit": "Zum Bearbeiten klicken",
      "result": "Ergebnis",
      "outputHint": "Was passiert als nächstes, wenn diese Bedingungen zutreffen? Bitte personenunabhängig formulieren (Gut: „Standardvertriebsprozess“, „Spezialvertriebsprozess“. Schlecht: „Weitergabe an Peter“)."
    },
    "placeholders": {
      "noInputsAddedYet": "Noch keine Eingaben hinzugefügt",
      "defineProcessStepDescription": "Beschreibe deinen Prozessschritt...",
      "choose": "Wählen",
      "enterCondition": "z.B. Bestellwert > 100€",
      "enterConditionAlt": "z.B. Bestellwert < 100€",
      "enterCondition2": "z.B. Kundentyp = Premium",
      "enterCondition2Alt": "z.B. Kundentyp = Standard",
      "enterOutput": "z.B. Automatisch genehmigen",
      "enterOutput2": "z.B. Genehmigung des Vorgesetzten anfordern"
    },
    "sections": {
      "inputsReceived": "Ereignisse & Informationen",
      "helpers": "Hilfsmittel"
    },
    "modals": {
      "eventModal": {
        "editEventTitle": "Startereignis bearbeiten",
        "createEventTitle": "Startereignis erstellen",
        "startEventDescription": "Was löst diesen Prozess aus? Lege fest, wodurch er beginnt.",
        "type": "Typ",
        "trigger": "Auslöser",
        "eventName": "Ereignisname",
        "selectTrigger": "Auslöser auswählen",
        "selectEventType": "Ereignistyp auswählen",
        "enterEventName": "Ereignisname eingeben",
        "describeWhatTriggers": "Beschreibe, was dieses Ereignis auslöst (z.B. Mitarbeiter reicht Urlaubsantrag ein)"
      },
      "decisionTable": {
        "title": "Entscheidungstabelle",
        "descriptionNew": "Lege Regeln mit eigenen Bedingungen fest. Jede Regel erzeugt eine Karte für den nächsten Bearbeiter.",
        "configureRulesDescription": "Lege Regeln fest, die bestimmen, wie es je nach Bedingung weitergeht.",
        "emptyCondition": "Leere Bedingung",
        "validationMessageNew": "Jede Regel muss mindestens eine Bedingung und eine Ausgabe ausgefüllt haben",
        "successorReminder": "Denk daran, nach dem Speichern jeder Regel einen nächsten Bearbeiter zuzuweisen",
        "defaultCondition": "Bedingung {{number}}",
        "editColumnName": "Klicke, um den Spaltennamen zu bearbeiten",
        "orSeparator": "oder"
      },
      "inputModal": {
        "editTitle": "Eingang bearbeiten",
        "viewTitle": "Eingang ansehen",
        "addTitle": "Eingang hinzufügen",
        "description": "Was kommt bei diesem Schritt herein – ein auslösendes Ereignis oder eine Information, die du verarbeitest",
        "inputTypeSection": "Art des Eingangs",
        "eventDetails": "Ereignisdetails",
        "informationDetails": "Informationsdetails",
        "inputTypeEvent": "Ereignis",
        "inputTypePreviousOutput": "Information (Aus vorhergehendem Schritt)",
        "informationName": "Informationsname",
        "enterInformationName": "Informationsname eingeben (z.B. Kundendetails)",
        "describeInformation": "Beschreibe, was diese Information enthält",
        "linkToProcessStep": "Information aus vorgelagertem Prozessschritt",
        "linkToProcessStepHint": "Wähle die Schritte, deren Ergebnis vorliegen muss, bevor dieser Schritt starten kann.",
        "selectProcessStep": "Schritt auswählen der Informationen für diesen Schritt liefert",
        "noCompletedSteps": "Keine abgeschlossenen Schritte verfügbar",
        "allStepsAlreadyLinked": "Alle verfügbaren Schritte sind bereits verknüpft",
        "outputLabel": "Ausgabe: {{output}}",
        "linkedStepNotFound": "Verknüpfter Schritt nicht mehr verfügbar",
        "inputType": "Typ",
        "selectInputType": "Eingabetyp auswählen"
      }
    },
    "helpersHeading": {
      "systems_one": "1 System",
      "systems_other": "{{count}} Systeme",
      "participants_one": "1 Beteiligter",
      "participants_other": "{{count}} Beteiligte",
      "colleagues_one": "1 Beteiligte",
      "colleagues_other": "{{count}} Beteiligte",
      "documents_one": "1 Unterlage",
      "documents_other": "{{count}} Unterlagen",
      "addHint": "Hinzufügen",
      "pendingSystem": "Vorgeschlagenes System",
      "pendingFunction": "Vorgeschlagenes Team bzw. vorgeschlagene Funktion"
    },
    "tooltips": {
      "input": "Füge hier alles hinzu, was hereinkommt und du benötigst, um den Prozessschritt umzusetzen: ein Ereignis, das den Schritt auslöst (z.B. Quartalsmeeting) oder eine Information, die du verarbeitest (z.B. ein Bericht oder Kennzahl). Reine Nachschlagewerke wie Richtlinien gehören dagegen unter ‚Unterlagen'.",
      "actionType": "Beschreibe, was in diesem Schritt geschieht. Ist es eine normale Tätigkeit, wähle ‚Aktivität'. Hängt der weitere Verlauf von Bedingungen ab (z.B. genehmigt/abgelehnt), wähle ‚Entscheidung'.",
      "helpers": "Womit und mit wem erledigst du diesen Schritt? Genutzte Systeme, zwingend eingebundene Personen und benötigte Unterlagen.",
      "documents": "Unterlagen ziehst du nur zu Rate – Richtlinien, Checklisten, Vorlagen. Sie bleiben unverändert. Was du dagegen verarbeitest und weitergibst, gehört als ‚Information' in den Eingang."
    }
  },
  "entityPicker": {
    "common": {
      "allFacet": "Alle",
      "noResults": "Keine Treffer",
      "recommendedBadge": "EMPFOHLEN",
      "matchInFieldTemplate": "— Treffer in {{field}}",
      "statsLine": "in {{occurrences}} von {{samples}} Aufnahmen ({{percent}} %)",
      "departmentFilterAll": "Alle Abteilungen",
      "departmentFilterAriaLabel": "Abteilung filtern",
      "departmentFilterPrefix": "Abteilung:",
      "fields": {
        "email": "E-Mail",
        "description": "Beschreibung",
        "role": "Stelle",
        "department": "Abteilung",
        "category": "Kategorie",
        "type": "Typ",
        "name": "Name"
      },
      "buckets": {
        "recentlyUsed": "Zuletzt von dir verwendet",
        "recentlyUsedSubtitle_one": "basierend auf deiner letzten Aufnahme",
        "recentlyUsedSubtitle_other": "basierend auf deinen letzten {{count}} Aufnahmen",
        "selected": "Ausgewählt ({{count}})",
        "pendingSuggestions": "Offene Vorschläge"
      },
      "selectedSectionLabel_one": "Ausgewählt ({{count}})",
      "selectedSectionLabel_other": "Ausgewählt ({{count}})",
      "removeChipAriaLabel": "{{name}} entfernen",
      "switchToAllLabel": "Alle {{count}} anzeigen",
      "switchToBucketsLabel": "Vorschläge anzeigen",
      "allGroupSelectedLabel": "Ausgewählt ({{count}})"
    },
    "system": {
      "title": "Systeme auswählen",
      "description": "Welche Systeme verwendest du in diesem Schritt? Mehrere möglich.",
      "searchPlaceholder": "Systemname, Hersteller oder Kategorie",
      "empty": "Keine passenden Systeme",
      "saveSingular": "Speichern (1 System)",
      "savePlural": "Speichern ({{count}} Systeme)",
      "saveZero": "Speichern",
      "requestNewTitle": "Neues System anfragen",
      "requestNewDescription": "Ein Administrator prüft den Vorschlag und nimmt das System auf.",
      "allGroupRestLabel": "Weitere Systeme ({{count}})",
      "showAllCtaTitle": "Alle Systeme durchsuchen",
      "showAllCtaMeta": "{{count}} Systeme · filterbar nach Kategorie",
      "suggestRowTitle": "System nicht dabei?",
      "suggestRowMeta": "Schlage ein neues System für die Aufnahmebibliothek vor.",
      "emptyStateCtaWithQuery": "„{{query}}\" als neues System vorschlagen",
      "emptyStateCtaBlank": "Neues System vorschlagen",
      "createRowMeta": "Lege ein neues System an.",
      "createCtaWithQuery": "„{{query}}\" als neues System erstellen",
      "createCtaBlank": "Neues System erstellen",
      "buckets": {
        "recentlyUsed": "Zuletzt von dir verwendet",
        "recentlyUsedSubtitle_one": "basierend auf deiner letzten Aufnahme",
        "recentlyUsedSubtitle_other": "basierend auf deinen letzten {{count}} Aufnahmen",
        "byRole": "In deiner Stelle üblich",
        "byRolePeerCount": "{{count}} Kollegen mit gleicher Stelle",
        "byProcess": "Für diesen Prozess",
        "byProcessSampleSize": "aus {{count}} ähnlichen Aufnahmen",
        "byDepartment": "In deiner Abteilung üblich",
        "byDepartmentPeerCount": "{{count}} Kollegen in deiner Abteilung",
        "annotation": {
          "recentlyUsed": "zuletzt von dir verwendet",
          "byRole": "{{count}} Kollegen nutzen dies",
          "byProcess": "in {{count}} ähnlichen Aufnahmen",
          "byDepartment": "{{count}} Kollegen in deiner Abteilung nutzen dies"
        }
      },
      "resultCount_one": "{{count}} Treffer",
      "resultCount_other": "{{count}} Treffer",
      "helperAvailableAsSuccessor": "Zuvor als Helfer vorgeschlagen"
    },
    "user": {
      "title": "Beteiligte auswählen",
      "description": "Wähle Personen, die in diesem Schritt aktiv mitwirken – z. B. zur Freigabe im 4-Augen-Prinzip oder bei einer gemeinsamen Bearbeitung. Mehrere möglich.",
      "searchPlaceholder": "Name, Stelle, Abteilung oder E-Mail",
      "empty": "Keine passenden Kollegen",
      "saveSingular": "Speichern (1 Kollege)",
      "savePlural": "Speichern ({{count}} Kollegen)",
      "saveZero": "Speichern",
      "allGroupRestLabel": "Weitere Kollegen ({{count}})",
      "showAllCtaTitle": "Alle Kollegen durchsuchen",
      "showAllCtaMeta": "{{count}} Kollegen · filterbar nach Abteilung",
      "buckets": {
        "byRole": "In deiner Stelle üblich",
        "byDepartment": "In deiner Abteilung üblich",
        "byProcess": "Häufig für diesen Prozessschritt"
      }
    },
    "helper": {
      "title": "Personen oder Funktionen auswählen",
      "description": "Wähle aus, wer in diesem Schritt aktiv mitwirkt – einzelne Personen oder ein ganzes Team bzw. eine Funktion. Mehrere möglich.",
      "saveSingular": "Speichern (1 Beteiligter)",
      "savePlural": "Speichern ({{count}} Beteiligte)",
      "kind": {
        "person": "Personen",
        "team": "Teams",
        "role": "Funktionen"
      }
    },
    "artifact": {
      "title": "Unterlage auswählen",
      "description": "Welche Unterlage ziehst du in diesem Schritt heran? Z. B. eine Richtlinie oder Checkliste.",
      "searchPlaceholder": "Suche in Name, Beschreibung, Typ und Tags",
      "empty": "Keine passenden Unterlagen",
      "noDataTitle": "Noch keine Unterlagen",
      "noDataMessage": "Lege deine erste Unterlage an, um sie mit Prozessschritten zu verknüpfen.",
      "saveSingular": "Speichern (1 Unterlage)",
      "savePlural": "Speichern ({{count}} Unterlagen)",
      "saveZero": "Speichern",
      "allGroupRestLabel": "Weitere Unterlagen ({{count}})",
      "showAllCtaTitle": "Alle Unterlagen durchsuchen",
      "showAllCtaMeta": "{{count}} Unterlagen · filterbar nach Typ",
      "suggestRowTitle": "Unterlage nicht gefunden?",
      "suggestRowMeta": "Leg eine neue Unterlage in der Bibliothek an",
      "emptyStateCtaWithQuery": "„{{query}}\" als neue Unterlage anlegen",
      "emptyStateCtaBlank": "Unterlage nicht gefunden? Neu anlegen",
      "buckets": {
        "byProcess": "Häufig für diesen Prozessschritt",
        "byType": "Typische {{type}}-Dokumente"
      }
    },
    "orgFunction": {
      "buckets": {
        "byDepartment": "In deiner Abteilung üblich",
        "byProcess": "Häufig für diesen Prozessschritt"
      },
      "helperAvailableAsSuccessor": "Zuvor für diesen Schritt vorgeschlagen"
    },
    "team": {
      "title": "Team auswählen",
      "description": "Welches Team übernimmt den nächsten Schritt?",
      "searchPlaceholder": "Name, Abteilung oder E-Mail",
      "empty": "Keine passenden Teams",
      "saveSingular": "Speichern (1 Team)",
      "savePlural": "Speichern ({{count}} Teams)",
      "saveZero": "Speichern",
      "allGroupRestLabel": "Weitere Teams ({{count}})",
      "showAllCtaTitle": "Alle Teams durchsuchen",
      "showAllCtaMeta": "{{count}} Teams · filterbar nach Abteilung",
      "suggestRowTitle": "Team nicht dabei?",
      "suggestRowMeta": "Schlage ein neues Team für die Aufnahmebibliothek vor.",
      "emptyStateCtaWithQuery": "„{{query}}\" als neues Team vorschlagen",
      "emptyStateCtaBlank": "Neues Team vorschlagen",
      "createRowMeta": "Lege ein neues Team an.",
      "createCtaWithQuery": "„{{query}}\" als neues Team erstellen",
      "createCtaBlank": "Neues Team erstellen"
    },
    "role": {
      "title": "Funktion auswählen",
      "description": "Welche Funktion übernimmt den nächsten Schritt?",
      "searchPlaceholder": "Name, Abteilung oder E-Mail",
      "empty": "Keine passenden Funktionen",
      "saveSingular": "Speichern (1 Funktion)",
      "savePlural": "Speichern ({{count}} Funktionen)",
      "saveZero": "Speichern",
      "allGroupRestLabel": "Weitere Funktionen ({{count}})",
      "showAllCtaTitle": "Alle Funktionen durchsuchen",
      "showAllCtaMeta": "{{count}} Funktionen · filterbar nach Abteilung",
      "suggestRowTitle": "Funktion nicht dabei?",
      "suggestRowMeta": "Schlage eine neue Funktion für die Aufnahmebibliothek vor.",
      "emptyStateCtaWithQuery": "„{{query}}\" als neue Funktion vorschlagen",
      "emptyStateCtaBlank": "Neue Funktion vorschlagen",
      "createRowMeta": "Lege eine neue Funktion an.",
      "createCtaWithQuery": "„{{query}}\" als neue Funktion erstellen",
      "createCtaBlank": "Neue Funktion erstellen"
    },
    "externalContact": {
      "title": "Externen Kontakt auswählen",
      "description": "An welchen externen Kontakt wird der Prozess übergeben?",
      "searchPlaceholder": "Name, Organisation, Typ, E-Mail oder Beschreibung",
      "empty": "Keine passenden Kontakte",
      "noDataTitle": "Noch keine externen Kontakte",
      "noDataMessage": "Füge einen ersten Kontakt hinzu (Kunde, Lieferant, Partner …), um ihn in Prozessschritten zu verwenden.",
      "saveSingular": "Speichern (1 Kontakt)",
      "savePlural": "Speichern ({{count}} Kontakte)",
      "saveZero": "Speichern",
      "allGroupRestLabel": "Weitere Kontakte ({{count}})",
      "showAllCtaTitle": "Alle Kontakte durchsuchen",
      "showAllCtaMeta": "{{count}} Kontakte · filterbar nach Typ",
      "suggestRowTitle": "Kontakt nicht dabei?",
      "suggestRowMeta": "Füge einen neuen externen Kontakt hinzu.",
      "emptyStateCtaWithQuery": "„{{query}}\" als neuen Kontakt hinzufügen",
      "emptyStateCtaBlank": "Kontakt nicht dabei? Hinzufügen",
      "buckets": {
        "byProcess": "Häufig für diesen Prozessschritt",
        "byType": "Typische {{type}}-Kontakte"
      }
    },
    "successor": {
      "title": "Nächster Bearbeiter",
      "breadcrumbAfter": "↳ Nach „{{stepName}}\" · Schritt {{stepNumber}}",
      "descriptionCollapsed": "Wer oder was übernimmt den nächsten Prozessschritt?",
      "descriptionExpanded": "Auswahl treffen oder Typ wechseln.",
      "sectionWhoOrWhat": "Wer oder was übernimmt?",
      "sectionNotYetDefined": "Noch nicht festgelegt",
      "sidebarTypeHeading": "Typ",
      "statusReadyToSave": "Bereit zu speichern.",
      "statusPickToContinue": "Wähle eine Option, um fortzufahren.",
      "saveError": "Der Nachfolger konnte nicht gespeichert werden. Bitte erneut versuchen.",
      "ctaConfirmEntity": "Speichern",
      "type": {
        "person": {
          "sublabel": "Eine Mitarbeiterin oder ein Mitarbeiter"
        },
        "team": {
          "sublabel": "Ein Team in der Organisation"
        },
        "role": {
          "sublabel": "Eine Funktion in der Organisation"
        },
        "system": {
          "sublabel": "Automatisierter Schritt"
        },
        "externalContact": {
          "sublabel": "Kunde, Partner, Behörde"
        },
        "unclear": {
          "sublabel": "Prozessverantwortliche entscheidet später"
        },
        "none": {
          "sublabel": "Der Prozess endet hier"
        }
      },
      "unclear": {
        "cardTitle": "Unklar — später entscheiden",
        "cardBody": "Schritt als unklar markieren. Der Prozessverantwortliche wird nach Abschluss der Aufnahme benachrichtigt und entscheidet dann, wer den nächsten Schritt übernimmt.",
        "willBeNotified": "WIRD BENACHRICHTIGT",
        "ctaConfirm": "Offen markieren"
      },
      "none": {
        "cardTitle": "Kein Nachfolger",
        "cardBody": "(Prozessende)",
        "warning": "Stelle sicher, dass keine Ausgabe an einen weiteren Schritt erwartet wird.",
        "ctaConfirm": "Prozess beenden"
      }
    },
    "assignee": {
      "title": "Schritt zuweisen",
      "descriptionCollapsed": "Wer oder was führt diesen Prozessschritt aus?",
      "descriptionExpanded": "Auswahl treffen oder Typ wechseln."
    },
    "starter": {
      "title": "Bearbeiter hinzufügen",
      "descriptionCollapsed": "Wer oder was startet diesen Prozess?",
      "descriptionExpanded": "Triff eine Auswahl oder ändere den Typ."
    },
    "reassign": {
      "title": "Nächster Bearbeiter",
      "descriptionCollapsed": "Wer oder was übernimmt den nächsten Prozessschritt?",
      "descriptionExpanded": "Auswahl treffen oder Typ wechseln."
    }
  },
  "recording": {
    "finishDisabled": {
      "title": "Noch nicht abschließbar:",
      "missingActionType": "Wähle, was dieser Schritt tut (Aufgabe oder Entscheidung)",
      "missingInput": "Füge mindestens eine Eingabe hinzu",
      "missingTaskDescription": "Beschreibe, was du in diesem Schritt tust",
      "missingSuccessor": "Wähle, wer oder was als Nächstes folgt",
      "missingOutput": "Definiere das Ergebnis dieses Schritts",
      "missingDecisionRule": "Vervollständige die Entscheidungsregeln"
    },
    "startDisabled": {
      "title": "Noch nicht startbar:",
      "missingStartEvent": "Konfiguriere das Startereignis",
      "missingSuccessor": "Wähle, wer oder was als Nächstes folgt"
    }
  }
}
